import {
  Box,
  Heading,
  HStack,
  VStack,
  Link as ChakraLink,
  Image,
  // useTheme, // ไม่ได้ใช้งาน สามารถลบออกได้
} from "@chakra-ui/react";
import {
  // VaxReserveIcon, // ไม่ได้ใช้งาน สามารถลบออกได้
  // VaxInfoIcon, // ไม่ได้ใช้งาน สามารถลบออกได้
  // DeseaseInfoIcon, // ไม่ได้ใช้งาน สามารถลบออกได้
  HomeIcon,
} from "./CustomIcon"; // สมมติว่า HomeIcon อยู่ใน CustomIcon
import { Link } from "react-router-dom";

// import { VaccineStockExp } from "./dashboard/VacineStockExp"; // ไม่ได้ใช้งาน สามารถลบออกได้

const LandingPage = () => {
  // const theme = useTheme(); // ไม่ได้ใช้งาน สามารถลบออกได้
  const fontSize = "clamp(0.8rem, 2.5vmin, 1.5rem)";
  const headerFontSize = "clamp(2rem, 2.5vmin, 3.5rem)";
  const subHeaderFontSize = "clamp(0.9rem, 3vmin, 2.5rem)";
  const topicFontSize = "clamp(1.2rem, 3vmin, 2rem)";
  const buttonSize = "clamp(120px, 28vmin, 450px)"; // ขนาดสำหรับปุ่มวงกลม
  const logoSize = "clamp(60px, 10vmin, 150px)"; // ขนาดสำหรับโลโก้

  return (
    <Box
      textAlign="center"
      p={["2vh 2vw", "2.5vh 3vw", "3vh 4vw"]} // ปรับ padding ให้ยืดหยุ่น
      minH="100vh" // ความสูงขั้นต่ำเต็มหน้าจอ
      maxH="100dvh" // ความสูงสูงสุดเต็มหน้าจอ (ใช้ dvh เพื่อจัดการกับ mobile browser toolbars)
      overflowY="auto" // อนุญาตให้ scroll ถ้าเนื้อหาล้นจริงๆ (เป็น fallback) แต่เป้าหมายคือไม่ให้ล้น
      backgroundImage="url('/bglanding.png')"
      backgroundSize="cover"
      backgroundPosition="center"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center" // จัดกลางแนวตั้ง ถ้าเนื้อหาน้อยกว่า 100vh
    >
      {/* Logo and Agency Name */}
      <VStack
        spacing="clamp(0.3rem, 1vh, 0.8rem)" // ปรับระยะห่างระหว่างโลโก้และชื่อหน่วยงาน
        mb="clamp(0.8rem, 2.5vh, 2rem)" // ปรับระยะห่างด้านล่างของกลุ่มโลโก้
        p={["1rem", "1.25rem", "1.5rem"]} // ลด padding ภายใน VStack นี้หากจำเป็น
        borderRadius="lg"
      >
        <Image
          src="/logo.png"
          alt="Logo"
          boxSize={logoSize} // ใช้ขนาดโลโก้ที่กำหนด
        />
        <Heading
          fontSize={headerFontSize} // ปรับขนาดฟอนต์ให้ยืดหยุ่น
          fontWeight={"normal"}
          color="white"
        >
          สำนักเทคโนโลยีชีวภัณฑ์สัตว์
        </Heading>
        <Heading
          fontSize={subHeaderFontSize} // ปรับขนาดฟอนต์ให้ยืดหยุ่น
          fontWeight={"simi-bold"}
          color="white"
        >
          Bureau of Veterinary Biologics
        </Heading>
      </VStack>

      {/* Main Sections */}
      <HStack
        spacing={["1rem", "1rem", "clamp(30px, 5vw, 100px)"]} // ปรับระยะห่างระหว่างปุ่ม (แนวตั้งสำหรับ mobile, แนวนอนสำหรับ desktop)
        flexDirection={["column", "column", "row"]} // เปลี่ยนเป็นแถวแนวนอนเมื่อจอใหญ่ขึ้น
        justifyContent="center"
        mt="clamp(0.8rem, 2.5vh, 2rem)" // ปรับระยะห่างด้านบนของกลุ่มปุ่ม
        alignItems="center"
      >
        {/* ปุ่มที่ 1: สั่งจองวัคซีน */}
        <Link to="/vaccinereservationlist">
          <VStack
            w={buttonSize}
            h={buttonSize}
            bg="white"
            borderRadius="full"
            borderWidth="clamp(2px, 0.7vmin, 5px)" // ปรับความหนาของเส้นขอบ
            boxShadow="2xl"
            justifyContent="center"
            alignItems="center"
            overflow="hidden"
            p={0}
            transition="transform 0.3s ease"
            _hover={{ transform: "scale(1.05)" }}
          >
            <Image
              src="/landingimages/vaxreservation.png"
              alt="สั่งจองวัคซีน"
              objectFit="cover"
              w="100%"
              h="100%"
            />
          </VStack>
          <Heading
            fontSize={topicFontSize}
            fontWeight={"normal"}
            color="white"
            mt="clamp(0.4rem, 1.5vh, 1rem)" // ปรับระยะห่างด้านบนของข้อความใต้ปุ่ม
            textAlign="center"
          >
            สั่งจองวัคซีน
          </Heading>
        </Link>

        {/* ปุ่มที่ 2: ข้อมูลวัคซีน */}
        <Link to="/vaccineinfo">
          <VStack
            w={buttonSize}
            h={buttonSize}
            bg="white"
            borderRadius="full"
            borderWidth="clamp(2px, 0.7vmin, 5px)"
            boxShadow="2xl"
            justifyContent="center"
            alignItems="center"
            overflow="hidden"
            p={0}
            transition="transform 0.3s ease"
            _hover={{ transform: "scale(1.05)" }}
          >
            <Image
              src="/landingimages/vaxinfo.png"
              alt="ข้อมูลวัคซีน"
              objectFit="cover"
              w="100%"
              h="100%"
            />
          </VStack>
          <Heading
            fontSize={topicFontSize}
            fontWeight={"normal"}
            color="white"
            mt="clamp(0.4rem, 1.5vh, 1rem)"
            textAlign="center"
          >
            ข้อมูลวัคซีน
          </Heading>
        </Link>

        {/* ปุ่มที่ 3: ข้อมูลโรคในสัตว์ */}
        <Link to="/diseaseinfo">
          <VStack
            w={buttonSize}
            h={buttonSize}
            bg="white"
            borderRadius="full"
            borderWidth="clamp(2px, 0.7vmin, 5px)"
            boxShadow="2xl"
            justifyContent="center"
            alignItems="center"
            overflow="hidden"
            p={0}
            transition="transform 0.3s ease"
            _hover={{ transform: "scale(1.05)" }}
          >
            <Image
              src="/landingimages/diseaseinfo.png"
              alt="ข้อมูลโรคในสัตว์"
              objectFit="cover"
              w="100%"
              h="100%"
            />
          </VStack>
          <Heading
            fontSize={topicFontSize}
            fontWeight={"normal"}
            color="white"
            mt="clamp(0.4rem, 1.5vh, 1rem)"
            textAlign="center"
          >
            ข้อมูลโรคในสัตว์
          </Heading>
        </Link>
      </HStack>

      {/* Footer Link */}
      <Box
        mt="clamp(1rem, 3vh, 2.5rem)" // ปรับระยะห่างด้านบนของเส้นคั่น
        w={["80%", "70%", "60%"]} // ปรับความกว้างของเส้นคั่น
        h="2px"
        bg="white"
        borderRadius="full"
      ></Box>
      <Box mt="clamp(0.8rem, 2.5vh, 2rem)">
        {" "}
        {/* ปรับระยะห่างด้านบนของลิงก์ Footer */}
        <ChakraLink as={Link} to="/home" color="blue.500">
          <HStack
            spacing="clamp(0.3rem, 1vw, 0.5rem)" // ปรับระยะห่างระหว่างไอคอนและข้อความ
            w="full"
            justifyContent="center"
            alignItems="center"
          >
            <HomeIcon
              style={{
                fontSize: "clamp(18px, 4vmin, 26px)", // ปรับขนาดไอคอนให้ยืดหยุ่น
                color: "white",
              }}
            />
            <Heading
              fontSize={topicFontSize}
              fontWeight={"normal"}
              color="white"
              mt={2} // ปรับ margin top เล็กน้อยเพื่อให้ตรงกับไอคอน
            >
              ไปยังหน้าหลัก
            </Heading>
          </HStack>
        </ChakraLink>
      </Box>
    </Box>
  );
};

export default LandingPage;
